import React from 'react';
import { GetAssureDetailsResponse } from 'api/actor';
import PersonDetailsHeader from './PersonDetailsHeader';
import PersonDetailsStat from './PersonDetailsStat';

interface PersonDetailsLayoutProps {
  personDetails: GetAssureDetailsResponse;
  children: React.ReactNode;
}

const PersonDetailsLayout: React.FC<PersonDetailsLayoutProps> = ({ personDetails, children }) => {
  return (
    <section className="w-full overflow-hidden border bg-white rounded-2xl">
      <PersonDetailsHeader personDetails={personDetails} />
      <div className="p-8 space-y-8 shadow-inner">
        <PersonDetailsStat personDetails={personDetails} />
        <div>
          {children}
        </div>
      </div>
    </section>
  );
};

export default PersonDetailsLayout;
